module.exports = __webpack_public_path__ + "static/media/mfd.358faf08.png";